<template>
  <div class="detail">
      <div class="detailTab">
        <div class="header">
          <div class="title">{{detail.name}}</div>
        </div>

        <div class="content" style="padding-top: 2vh;">
          <div class="item">
            <div class="label">编号：</div>
            <div class="value">{{ detail.code }}</div>
          </div>
          <div class="item">
            <div class="label">名称：</div>
            <div class="value">{{ detail.name }}</div>
          </div>

          <div class="item">
            <div class="label">液位：</div>
            <div
              class="value"
            >{{ realTimeData.liquidLevel != undefined ? realTimeData.liquidLevel + "m" : "--" }}</div>
          </div>
          <div class="item">
            <div class="label">流速</div>
            <div
              class="value"
            >{{ realTimeData.flowspeed != undefined ? realTimeData.flowspeed + "m/s" : "--" }}</div>
          </div>
          <div class="item">
            <div class="label">温度：</div>
            <div
              class="value"
            >{{ realTimeData.temperature != undefined ? realTimeData.temperature + " ℃" : "--" }}</div>
          </div>

          <div class="item">
            <div class="label">更新时间：</div>
            <div class="value">{{ realTimeData.ts ? realTimeData.ts : "--" }}</div>
          </div>
        </div>

        <div style="padding: 1.5vh 1vw">统计数据</div>
          <div class="tabDetailQuery">
    <!--      <a-range-picker size="small" style="width: 13vw" v-model="selectedDate" :allowClear="false" />-->
            <RangePickerField style="margin: 0.5rem 0.2rem;width: 28%;" labelWidth="0"
                              v-model="selectedDate" :placeholder="['开始日期', '结束日期']" :disabled="false" @change="handleDateChange"/>
            <SelectField placeholder="指标" style="margin: 0.5rem 0.2rem;width: 20%;" label-width="0" id="category" v-model="queryOption" :options="queryOptions"/>
            <SelectField placeholder="间隔" style="margin: 0.5rem 0.2rem;width: 20%;" label-width="0" id="category" v-model="interval" :options="statInterval"/>
            <a-space style="margin-left: 1.5rem;">
                <ButtonField text="查询" @click="query" secondary />
                <ButtonField text="重置" primary @click="reset"/>
            </a-space>
          </div>
        <div style="padding-top: 1vh"></div>
        <Chart id="history-chart" :list="chartList" :rainList="rainList" />
        <div style="padding-top: 1vh"></div>
        <Tablelist :showCheckbox="false" :list="tableList" :columns="tableColumns"/>
      </div>
  </div>
</template>
  
<script>
import Chart from "./chart.vue";
import moment from "moment";
import request from "@/api/request";
import { mapGetters } from "vuex";
import RangePickerField from "@/components/water-affairs-style/field/RangePickerField.vue";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
import Tablelist from "@/components/water-affairs-style/table-list.vue";

export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
      Tablelist,ButtonField,SelectField,RangePickerField,Chart,
  },

  data() {
    return {
      selectedDate: [moment().subtract(1, "months"), moment()],
      queryOption: "liquidLevel",
      queryOptions: [
        {
          name: "液位",
          value: "liquidLevel",
        },
        {
          name: "流速",
          value: "flowspeed",
        },
        {
          name: "温度",
          value: "temperature",
        },
      ],
      interval: "1d",
      loading: false,
      chartList: [],
      rainList: [],
      tableList: [],
      realTimeData: {},
      tableColumns: [
          {
              key: 'liquidLevel',
              title: '液位(米)',
              field: 'liquidLevel',
              infotype: 'text'
          },
          {
              key: 'temperature',
              title: '温度(℃)',
              field: 'temperature',
              infotype: 'text'
          },
          {
              key: 'flowspeed',
              title: '流速(米/秒)',
              field: 'flowspeed',
              infotype: 'text'
          },
          {
              key: 'ts',
              title: '更新时间',
              field: 'ts',
              infotype: 'text'
          },
      ],
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),

    statInterval() {
      return this.findDataDict("statInterval");
    },
  },

  watch: {
    detail: {
      handler() {
        if (this.detail.sn) {
          this.getRealTimeData();
          this.getHistoryData();
        }
      },
      deep: true,
    },
  },

  methods: {
    handleDateChange(dates, dateStrings) {
        console.log('日期范围变化：', dates, dateStrings);
    },
    getHistoryData() {
      this.loading = true;

      request({
        url: "/data-service/dev/stat",
        method: "post",
        data: {
          devType: this.detail.type,
          beginDate: this.selectedDate[0].format("YYYY-MM-DD") + " 00:00:00",
          endDate: this.selectedDate[1].format("YYYY-MM-DD") + " 00:00:00",
          eids: [this.detail.sn],
          interval: this.interval,
        },
      })
        .then((res) => {
          if (Array.isArray(res)) {
            this.tableList = res;

            this.chartList = res.map((item) => {
              return {
                ts: item.ts,
                name: this.queryOptions.find(
                  (item) => item.value === this.queryOption
                ).name,
                value: item[this.queryOption],
              };
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });

      request({
        url: "/model-analysis/pipe/device/query/type/rainFall",
      }).then((res) => {
        console.log("rain config", res);

        if (Array.isArray(res) && res.length > 0) {
          if (res[0].sn) {
            request({
              url: "/data-service/dev/stat",
              method: "post",
              data: {
                devType: "rainFall",
                beginDate:
                  this.selectedDate[0].format("YYYY-MM-DD") + " 00:00:00",
                endDate:
                  this.selectedDate[1].format("YYYY-MM-DD") + " 00:00:00",
                eids: [res[0].sn],
                interval: this.interval,
              },
            }).then((res) => {
              console.log("flow detail", res);
              if (Array.isArray(res)) {
                this.rainList = Object.freeze(
                  res.map((item) => {
                    return {
                      ts: item.ts,
                      name: "雨量",
                      value: item.rainfall,
                    };
                  })
                );
              }
            });
          }
        }
      });
    },

    query() {
      this.getHistoryData();
    },
    reset() {
      this.selectedDate = [moment().subtract(1, "months"), moment()];
      this.queryOption = "liquidLevel";
      this.interval = "1d";
      this.getHistoryData();
    },

    getRealTimeData() {
      request({
        url: "/data-service/dev/realTime",
        method: "post",
        data: {
          devType: this.detail.type, // 获取类型
          eids: [this.detail.sn],
        },
      }).then((res) => {
        this.realTimeData = res || {};
      });
    },
  },
};
</script>
  
  
<style lang="less" scoped>
.detail {
  position: fixed;
  top: 11vh;
  height: 87vh;
  overflow-y: auto;
  right: 1vw;
  z-index: 99;
  width: 50vw;
  background-color: var(--detail-bgcolor);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #065645;
  color: #adadad;
  .detailTab{
    width: 96%;
    margin: auto;
  }
  & > .header {
    background-color: var(--theme-color);
    color: #fff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1vw;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .content {
    padding: 0 1vw;
    display: flex;
    flex-wrap: wrap;
    gap: 1vh;

    .item {
      width: 33%;
      display: flex;
      align-items: center;

      .label {
        min-width: 4em;
      }

      .value {
        color: var(--theme-color);
      }
    }
  }
}

.tabDetailQuery{
  display: flex;
  justify-content: start;
}
</style>